import cookie from 'js-cookie';
import { onAgeChecked } from './age-check';

const cookieInfoEls = document.querySelectorAll<HTMLElement>(
	'[data-cookie-info]',
);

cookieInfoEls.forEach((el) => {
	if (cookie.get('accepted_cookies')) {
		el.parentElement?.removeChild(el);
	}

	el.style.display = 'none';
	onAgeChecked(() => {
		el.style.display = 'block';
		el.classList.add('cookie-info--in');
		el.addEventListener('animationend', () => {
			el.classList.remove('cookie-info--in');
		});
	});

	const button = el.querySelector<HTMLElement>('[data-accept-button]');

	button?.addEventListener('click', () => {
		cookie.set('accepted_cookies', 'yes');
		el.addEventListener('transformend', () => {
			el.parentElement?.removeChild(el);
		});
		el.classList.add('cookie-info--out');
		console.log('click!');
	});
});

export default cookieInfoEls;
